import React, { FC } from 'react';

import { useI18n } from '#hooks/useI18n';

import { Can } from '#/components/roles/Can';
import { CanInDefaultOrganization } from '#/components/roles/CanInDefaultOrganization';
import { NavigationLink } from '#/containers/asideNavigation/components/NavigationLink';
import { SectionProps } from '#/containers/asideNavigation/Sections';
import { Private } from '#/containers/router/routes/Private';
import { UserRolesTypes } from '#/models';
import { getEnvironment } from '#lib/Config';

interface Props extends SectionProps {}

export const Investment: FC<Props> = ({ onClickItem, isMobile }) => {
  const { t } = useI18n();
  const roles: UserRolesTypes[] = ['buildingManager', 'admin', 'ownerManager', 'agent'];
  return (
    <CanInDefaultOrganization>
      <Can hasRoles={roles}>
        <NavigationLink
          to={Private.INVESTMENT.route}
          icon="wallet"
          title={t('asideNavigation.investment')}
          onClick={onClickItem}
          isMobile={isMobile}
        />
      </Can>
    </CanInDefaultOrganization>
  );
};
